import { DocuGistSearchOperator } from '@dealpoint/api-models'
import { IContractSearchQuery } from '@dealpoint/types'
import castArray from 'lodash/castArray'

export default function combineFilters({
  contractInformationFilters,
  keyTermFilters,
}: IContractSearchQuery) {
  return (contractInformationFilters ?? []).concat(keyTermFilters ?? []).reduce(
    (acc, f) =>
      f.disabled
        ? acc
        : acc.concat({
            id: f.id,
            searchTerm: {
              operator: f.operator as unknown as DocuGistSearchOperator,
              termId: f.termId,
              value: castArray(f.value),
            },
          }),
    []
  )
}
